/* Copyright (c) 2020-present CloudIO Inc */

/* eslint-disable no-template-curly-in-string */

import { ComponentSample, Item } from 'componentregistry';

const page: {
  root: Item<'Page'>;
  plusIcon: Item<'Icon'>;
  rowAction: Item<'RowAction'>;
  trashIcon: Item<'Icon'>;
  canvasGrid: Item<'CanvasGrid'>;
  iconColumn: Item<'IconColumn'>;
  pencilIcon: Item<'Icon'>;
  rowAction1: Item<'RowAction'>;
  starColumn: Item<'StarColumn'>;
  iconColumn1: Item<'IconColumn'>;
  imageColumn: Item<'ImageColumn'>;
  showMessage: Item<'ActionShowMessage'>;
  buttonColumn: Item<'ButtonColumn'>;
  showMessage1: Item<'ActionShowMessage'>;
  showMessage2: Item<'ActionShowMessage'>;
  showMessage3: Item<'ActionShowMessage'>;
  showMessage4: Item<'ActionShowMessage'>;
  showMessage5: Item<'ActionShowMessage'>;
  showMessage6: Item<'ActionShowMessage'>;
  showMessage7: Item<'ActionShowMessage'>;
  showMessage8: Item<'ActionShowMessage'>;
  switchColumn: Item<'SwitchColumn'>;
  userPicColumn: Item<'UserPicColumn'>;
  triggerOnClick: Item<'TriggerOnClick'>;
  rowNumberColumn: Item<'RowNumberColumn'>;
  triggerOnClick1: Item<'TriggerOnClick'>;
  triggerOnClick2: Item<'TriggerOnClick'>;
  triggerOnClick3: Item<'TriggerOnClick'>;
  triggerOnClick4: Item<'TriggerOnClick'>;
  triggerOnClick5: Item<'TriggerOnClick'>;
  triggerOnClick6: Item<'TriggerOnClick'>;
  triggerOnClick7: Item<'TriggerOnClick'>;
  triggerOnClick8: Item<'TriggerOnClick'>;
  switchColumnCase: Item<'SwitchColumnCase'>;
  actionIconsColumn: Item<'ActionIconsColumn'>;
  switchColumnCase1: Item<'SwitchColumnCase'>;
  buttonButtonColumn: Item<'ButtonColumn'>;
  dateTimeDateColumn: Item<'DateColumn'>;
  numberNumberColumn: Item<'NumberColumn'>;
  rowSelectionColumn: Item<'RowSelectionColumn'>;
  selectSelectColumn: Item<'SelectColumn'>;
  booleanCheckboxColumn: Item<'CheckboxColumn'>;
  firstNameStringColumn: Item<'StringColumn'>;
  checkboxCheckboxColumn: Item<'CheckboxColumn'>;
  progressIndicatorColumn: Item<'ProgressIndicatorColumn'>;
  testAliasLocalDataStore: Item<'LocalDataStore'>;
  renderAsPillStringColumn: Item<'StringColumn'>;
  testAliasDataStoreReference: Item<'DataStoreReference'>;
  withLetterAvatarStringColumn: Item<'StringColumn'>;
} = {
  actionIconsColumn: {
    children: ['plusIcon', 'pencilIcon', 'trashIcon'],
    itemId: 'actionIconsColumn',
    parent: 'canvasGrid',
    props: {
      alignment: 'center',
      showOnlyOnHover: true,
    },
    type: 'ActionIconsColumn',
  },
  booleanCheckboxColumn: {
    children: [],
    itemId: 'booleanCheckboxColumn',
    parent: 'canvasGrid',
    props: {
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: { type: 'text', value: 'Boolean' },
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'boolean',
      width: 65,
    },
    type: 'CheckboxColumn',
  },
  buttonButtonColumn: {
    children: ['triggerOnClick7'],
    itemId: 'buttonButtonColumn',
    parent: 'switchColumnCase',
    props: {
      label: { type: 'text', value: 'Button' },
      text: {
        type: 'expression',
        value: '$.testAlias.firstName',
      },
    },
    type: 'ButtonColumn',
  },
  buttonColumn: {
    children: ['triggerOnClick6'],
    itemId: 'buttonColumn',
    parent: 'canvasGrid',
    props: {
      label: { type: 'text', value: 'Button' },
      showOnlyOnHover: true,
      text: {
        type: 'text',
        value: 'Click Me!',
      },
    },
    type: 'ButtonColumn',
  },
  canvasGrid: {
    children: [
      'rowNumberColumn',
      'rowSelectionColumn',
      'withLetterAvatarStringColumn',
      'renderAsPillStringColumn',
      'progressIndicatorColumn',
      'starColumn',
      'iconColumn',
      'switchColumn',
      'actionIconsColumn',
      'imageColumn',
      'userPicColumn',
      'numberNumberColumn',
      'buttonColumn',
      'dateTimeDateColumn',
      'booleanCheckboxColumn',
      'checkboxCheckboxColumn',
      'selectSelectColumn',
      'firstNameStringColumn',
    ],
    itemId: 'canvasGrid',
    parent: 'testAliasDataStoreReference',
    props: {
      rowHeight: 36,
      updatable: {
        type: 'expression',
        value: '$.testAlias.id % 2 === 0',
      },
    },
    type: 'CanvasGrid',
  },
  checkboxCheckboxColumn: {
    children: [],
    itemId: 'checkboxCheckboxColumn',
    parent: 'canvasGrid',
    props: {
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: { type: 'text', value: 'Checkbox' },
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'checkbox',
      width: 80,
    },
    type: 'CheckboxColumn',
  },
  dateTimeDateColumn: {
    children: [],
    itemId: 'dateTimeDateColumn',
    parent: 'canvasGrid',
    props: {
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: { type: 'text', value: 'Date Time' },
      showTime: true,
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'dateTime',
      width: 120,
    },
    type: 'DateColumn',
  },
  firstNameStringColumn: {
    children: [],
    itemId: 'firstNameStringColumn',
    parent: 'canvasGrid',
    props: {
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: { type: 'text', value: 'String Column' },
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'firstName',
      width: 186,
    },
    type: 'StringColumn',
  },
  iconColumn: {
    children: ['triggerOnClick5'],
    itemId: 'iconColumn',
    parent: 'canvasGrid',
    props: {
      icon: {
        iconName: 'edit',
        iconType: 'light',
      },
      label: { type: 'text', value: 'Icon' },
      showOnlyOnHover: true,
      toolTip: {
        type: 'text',
        value: 'Edit',
      },
      width: 57,
    },
    type: 'IconColumn',
  },
  iconColumn1: {
    children: ['triggerOnClick8'],
    itemId: 'iconColumn1',
    parent: 'switchColumnCase1',
    props: {
      icon: {
        iconName: 'edit',
        iconType: 'light',
      },
      label: { type: 'text', value: 'Icon' },
      toolTip: {
        type: 'text',
        value: 'Edit',
      },
      width: 57,
    },
    type: 'IconColumn',
  },
  imageColumn: {
    children: [],
    itemId: 'imageColumn',
    parent: 'canvasGrid',
    props: {
      alignment: 'center',
      label: { type: 'text', value: 'Image' },
      rounding: 8,
      viewAttribute: 'imageUrl',
      width: 73,
    },
    type: 'ImageColumn',
  },
  numberNumberColumn: {
    children: [],
    itemId: 'numberNumberColumn',
    parent: 'canvasGrid',
    props: {
      formatFunction: 'formatCurrency',
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: { type: 'text', value: 'Number' },
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'number',
      width: 79,
    },
    type: 'NumberColumn',
  },
  pencilIcon: {
    children: ['triggerOnClick3'],
    itemId: 'pencilIcon',
    parent: 'actionIconsColumn',
    props: {
      icon: {
        iconName: 'pencil',
        iconType: 'light',
      },
      toolTip: {
        type: 'text',
        value: 'Update',
      },
    },
    type: 'Icon',
  },
  plusIcon: {
    children: ['triggerOnClick2'],
    itemId: 'plusIcon',
    parent: 'actionIconsColumn',
    props: {
      color: {
        type: 'expression',
        value: '$.theme.palette.primary.main',
      },
      icon: {
        iconName: 'plus',
        iconType: 'light',
      },
      toolTip: {
        type: 'text',
        value: 'Add',
      },
    },
    type: 'Icon',
  },
  progressIndicatorColumn: {
    children: [],
    itemId: 'progressIndicatorColumn',
    parent: 'canvasGrid',
    props: {
      label: { type: 'text', value: 'Progress Indicator' },
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'percent',
    },
    type: 'ProgressIndicatorColumn',
  },
  renderAsPillStringColumn: {
    children: [],
    itemId: 'renderAsPillStringColumn',
    parent: 'canvasGrid',
    props: {
      alignment: 'center',
      bgColorExpression: {
        type: 'expression',
        value: 'getColor($.testAlias.firstName)',
      },
      colorExpression: {
        type: 'expression',
        value: 'getReadableColor(getColor($.testAlias.firstName))',
      },
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: { type: 'text', value: 'Render As Pill' },
      renderAsPill: true,
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'firstName',
      width: 157,
    },
    type: 'StringColumn',
  },
  root: {
    children: ['testAliasLocalDataStore', 'testAliasDataStoreReference'],
    itemId: 'root',
    parent: 'root',
    props: {
      padding: {
        all: 0,
      },
      windowTitle: {
        type: 'text',
        value: 'Blank Page',
      },
    },
    type: 'Page',
  },
  rowAction: {
    children: ['triggerOnClick'],
    itemId: 'rowAction',
    parent: 'rowSelectionColumn',
    props: {
      icon: {
        iconName: 'apple-alt',
        iconType: 'light',
      },
      maxRowsSelected: 1,
      text: {
        type: 'text',
        value: 'Single Row Action',
      },
    },
    type: 'RowAction',
  },
  rowAction1: {
    children: ['triggerOnClick1'],
    itemId: 'rowAction1',
    parent: 'rowSelectionColumn',
    props: {
      icon: {
        iconName: 'align-justify',
        iconType: 'light',
      },
      text: {
        type: 'text',
        value: 'Multi row action',
      },
    },
    type: 'RowAction',
  },
  rowNumberColumn: {
    children: [],
    itemId: 'rowNumberColumn',
    parent: 'canvasGrid',
    props: {
      label: { type: 'text', value: '#' },
      width: 60,
    },
    type: 'RowNumberColumn',
  },
  rowSelectionColumn: {
    children: ['rowAction', 'rowAction1'],
    itemId: 'rowSelectionColumn',
    parent: 'canvasGrid',
    props: {},
    type: 'RowSelectionColumn',
  },
  selectSelectColumn: {
    children: [],
    itemId: 'selectSelectColumn',
    parent: 'canvasGrid',
    props: {
      formatFunction: 'formatGenderSelect',
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: { type: 'text', value: 'Select' },
      optionValues: { type: 'text', value: 'M:Male,F:Female,O:Other' },
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'gender',
      width: 94,
    },
    type: 'SelectColumn',
  },
  showMessage: {
    children: [],
    itemId: 'showMessage',
    parent: 'triggerOnClick',
    props: {
      message: {
        type: 'expression',
        value:
          '`Single row action performed on row with id ${$.testAlias.id + 1}`',
      },
      type: 'info',
    },
    type: 'ActionShowMessage',
  },
  showMessage1: {
    children: [],
    itemId: 'showMessage1',
    parent: 'triggerOnClick2',
    props: {
      message: {
        type: 'text',
        value: 'Add icon clicked',
      },
      type: 'info',
    },
    type: 'ActionShowMessage',
  },
  showMessage2: {
    children: [],
    itemId: 'showMessage2',
    parent: 'triggerOnClick1',
    props: {
      message: {
        type: 'text',
        value: 'Multi row action clicked',
      },
      type: 'info',
    },
    type: 'ActionShowMessage',
  },
  showMessage3: {
    children: [],
    itemId: 'showMessage3',
    parent: 'triggerOnClick3',
    props: {
      message: {
        type: 'text',
        value: 'Update icon clicked',
      },
      type: 'info',
    },
    type: 'ActionShowMessage',
  },
  showMessage4: {
    children: [],
    itemId: 'showMessage4',
    parent: 'triggerOnClick4',
    props: {
      message: {
        type: 'text',
        value: 'Delete icon clicked',
      },
      type: 'info',
    },
    type: 'ActionShowMessage',
  },
  showMessage5: {
    children: [],
    itemId: 'showMessage5',
    parent: 'triggerOnClick5',
    props: {
      message: {
        type: 'text',
        value: 'Update icon clicked',
      },
      type: 'info',
    },
    type: 'ActionShowMessage',
  },
  showMessage6: {
    children: [],
    itemId: 'showMessage6',
    parent: 'triggerOnClick6',
    props: {
      message: {
        type: 'text',
        value: 'Button clicked',
      },
      type: 'info',
    },
    type: 'ActionShowMessage',
  },
  showMessage7: {
    children: [],
    itemId: 'showMessage7',
    parent: 'triggerOnClick7',
    props: {
      message: {
        type: 'text',
        value: 'Button clicked',
      },
      type: 'info',
    },
    type: 'ActionShowMessage',
  },
  showMessage8: {
    children: [],
    itemId: 'showMessage8',
    parent: 'triggerOnClick8',
    props: {
      message: {
        type: 'text',
        value: 'Update icon clicked',
      },
      type: 'info',
    },
    type: 'ActionShowMessage',
  },
  starColumn: {
    children: [],
    itemId: 'starColumn',
    parent: 'canvasGrid',
    props: {
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: { type: 'text', value: 'Star Rating' },
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'rating',
    },
    type: 'StarColumn',
  },
  switchColumn: {
    children: ['switchColumnCase', 'switchColumnCase1'],
    itemId: 'switchColumn',
    parent: 'canvasGrid',
    props: {
      expression: {
        type: 'expression',
        value: '$.testAlias.checkbox',
      },
      label: { type: 'text', value: 'Switch Column' },
    },
    type: 'SwitchColumn',
  },
  switchColumnCase: {
    children: ['buttonButtonColumn'],
    itemId: 'switchColumnCase',
    parent: 'switchColumn',
    props: {
      case: 'Y',
    },
    type: 'SwitchColumnCase',
  },
  switchColumnCase1: {
    children: ['iconColumn1'],
    itemId: 'switchColumnCase1',
    parent: 'switchColumn',
    props: {
      case: 'N',
    },
    type: 'SwitchColumnCase',
  },
  testAliasDataStoreReference: {
    children: ['canvasGrid'],
    itemId: 'testAliasDataStoreReference',
    parent: 'root',
    props: {
      alias: 'testAlias',
    },
    type: 'DataStoreReference',
  },
  testAliasLocalDataStore: {
    children: [],
    itemId: 'testAliasLocalDataStore',
    parent: 'root',
    props: {
      alias: 'testAlias',
      dataFormat: 'ts',
      dataSource: 'test',
      tsData:
        "const dateTime = new Date().toISOString();\nconst data = Array.from(Array(10000).keys()).map((_, i) => {\n  const rating = Math.ceil(Math.random() * 5);\n  const n = Math.round(Math.random() * 100);\n  return {\n    id: i,\n    firstName: `Row ${i + 1}`,\n    number: Math.round(Math.random() * 10000) / 100,\n    dateTime,\n    boolean: rating % 2 !== 0,\n    checkbox: rating % 2 ? 'N' : 'Y',\n    percent: Math.random(),\n    gender: rating % 3 === 0 ? 'M' : 'F',\n    rating,\n    imageUrl: `https://picsum.photos/id/${n}/100/100`,\n  };\n});\nreturn data;",
    },
    type: 'LocalDataStore',
  },
  trashIcon: {
    children: ['triggerOnClick4'],
    itemId: 'trashIcon',
    parent: 'actionIconsColumn',
    props: {
      color: {
        type: 'expression',
        value: '$.theme.palette.error.main',
      },
      icon: {
        iconName: 'trash',
        iconType: 'light',
      },
      toolTip: {
        type: 'text',
        value: 'Delete',
      },
    },
    type: 'Icon',
  },
  triggerOnClick: {
    children: ['showMessage'],
    itemId: 'triggerOnClick',
    parent: 'rowAction',
    props: {},
    type: 'TriggerOnClick',
  },
  triggerOnClick1: {
    children: ['showMessage2'],
    itemId: 'triggerOnClick1',
    parent: 'rowAction1',
    props: {},
    type: 'TriggerOnClick',
  },
  triggerOnClick2: {
    children: ['showMessage1'],
    itemId: 'triggerOnClick2',
    parent: 'plusIcon',
    props: {},
    type: 'TriggerOnClick',
  },
  triggerOnClick3: {
    children: ['showMessage3'],
    itemId: 'triggerOnClick3',
    parent: 'pencilIcon',
    props: {},
    type: 'TriggerOnClick',
  },
  triggerOnClick4: {
    children: ['showMessage4'],
    itemId: 'triggerOnClick4',
    parent: 'trashIcon',
    props: {},
    type: 'TriggerOnClick',
  },
  triggerOnClick5: {
    children: ['showMessage5'],
    itemId: 'triggerOnClick5',
    parent: 'iconColumn',
    props: {},
    type: 'TriggerOnClick',
  },
  triggerOnClick6: {
    children: ['showMessage6'],
    itemId: 'triggerOnClick6',
    parent: 'buttonColumn',
    props: {},
    type: 'TriggerOnClick',
  },
  triggerOnClick7: {
    children: ['showMessage7'],
    itemId: 'triggerOnClick7',
    parent: 'buttonButtonColumn',
    props: {},
    type: 'TriggerOnClick',
  },
  triggerOnClick8: {
    children: ['showMessage8'],
    itemId: 'triggerOnClick8',
    parent: 'iconColumn1',
    props: {},
    type: 'TriggerOnClick',
  },
  userPicColumn: {
    children: [],
    itemId: 'userPicColumn',
    parent: 'canvasGrid',
    props: {
      label: { type: 'text', value: 'User Profile' },
      showUserName: true,
      viewAttribute: 'lastUpdatedBy',
    },
    type: 'UserPicColumn',
  },
  withLetterAvatarStringColumn: {
    children: [],
    itemId: 'withLetterAvatarStringColumn',
    parent: 'canvasGrid',
    props: {
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: { type: 'text', value: 'With Letter Avatar' },
      renderLetterAvatar: 'on',
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'firstName',
      width: 186,
    },
    type: 'StringColumn',
  },
};

const controller = `import React from 'react';
import { Box } from '@mui/material';
import type { FormatColumnValueFunction, IconValueWithToolTip } from 'cloudio';

const NF = {
  USD: new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }),
};

const formatCurrency: FormatColumnValueFunction = ({ viewAttribute, value, rawValue, record, theme }) => {
  if (typeof rawValue === 'number') {
      return NF.USD.format(rawValue);
  }
  return value;
}

const formatGenderSelect: FormatColumnValueFunction = ({ viewAttribute, value, rawValue, record, theme }) => {
  if (rawValue) {
      let icon: IconValueWithToolTip | undefined;
      switch (rawValue) {
          case 'M':
              icon = { iconName: 'user-hard-hat', color: theme.palette.primary.main, iconType: 'light' };
              break;
          default:
              icon = { iconName: 'user', color: 'pink', iconType: 'light', iconSize: 16, tooltip: \`some tooltip... \${value}\` };
              break;
      }
      return { value, icon };
  }
  return value;
}


// must export a default object with all the functions to be used by this page
export default {
  formatGenderSelect,
  formatCurrency,
}`;

export const helpRenders: ComponentSample<'CanvasGrid'>[] = [
  {
    title: 'Canvas Grid with 10K rows',
    description: 'Canvas Grid with various column types and 10K rows',
    page,
    controller,
    exampleId: 'eg-01GJ2CEAGJV56G8MRVFSHP1027',
    clearParentChildren: true,
    height: 680,
    visibleProps: [
      'rowHeight',
      'updatable',
      'stripeRows',
      'highlightRow',
      'showColumnLines',
      'headerBackgroundColor',
      'pinnable',
      'sortable',
      'highlightActiveRow',
    ],
    item: {
      type: 'CanvasGrid',
      props: {
        rowHeight: 36,
        updatable: {
          type: 'expression',
          value: '$.testAlias.id % 2 === 0',
        },
      },
      itemId: 'canvasGrid',
      parent: 'testAliasDataStoreReference',
      children: [
        'rowNumberColumn',
        'rowSelectionColumn',
        'withLetterAvatarStringColumn',
        'renderAsPillStringColumn',
        'progressIndicatorColumn',
        'starColumn',
        'iconColumn',
        'switchColumn',
        'actionIconsColumn',
        'imageColumn',
        'userPicColumn',
        'numberNumberColumn',
        'buttonColumn',
        'dateTimeDateColumn',
        'booleanCheckboxColumn',
        'checkboxCheckboxColumn',
        'selectSelectColumn',
        'firstNameStringColumn',
      ],
    },
  },
];
